var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 81.253 90 H 8.747 c -1.697 0 -3.072 -1.375 -3.072 -3.072 V 34.121 h 78.65 v 52.807 C 84.325 88.625 82.95 90 81.253 90 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(243,172,71)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45,0 5.67,34.12 5.67,34.12 5.67,34.12 45,68.24 84.33,34.12 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(69,96,116)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 55.879 L 6.645 89.158 C 7.195 89.677 7.931 90 8.747 90 h 72.507 c 0.815 0 1.552 -0.323 2.102 -0.842 C 81.509 87.557 45 55.879 45 55.879 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(241,154,61)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16.173 7.816 v 21.89 v 9.524 l 21.702 18.831 L 45 51.879 c 0 0 2.909 2.524 7.125 6.182 L 73.827 39.23 v -9.524 V 7.816 H 16.173 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(240,240,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 46.908 33.28 c -0.521 0.752 -1.107 1.307 -1.762 1.665 c -0.655 0.357 -1.438 0.536 -2.347 0.536 c -1.495 0 -2.638 -0.404 -3.427 -1.212 c -0.789 -0.808 -1.184 -2.005 -1.184 -3.593 c 0 -2.219 0.657 -4.09 1.971 -5.612 c 1.313 -1.523 2.937 -2.284 4.867 -2.284 c 0.705 0 1.322 0.142 1.852 0.425 s 0.977 0.712 1.338 1.288 l 0.725 -1.281 h 2.869 l -2.131 8.495 l -0.016 0.082 l -0.041 0.368 c 0 0.272 0.074 0.475 0.223 0.606 s 0.367 0.197 0.654 0.197 c 1.273 0 2.389 -0.667 3.35 -2.001 s 1.441 -2.886 1.441 -4.656 c 0 -2.205 -0.836 -4.012 -2.506 -5.42 c -0.836 -0.695 -1.793 -1.219 -2.869 -1.571 c -1.078 -0.352 -2.289 -0.528 -3.635 -0.528 c -1.375 0 -2.646 0.169 -3.816 0.508 c -1.17 0.339 -2.237 0.848 -3.203 1.525 c -1.43 1.012 -2.537 2.284 -3.321 3.816 c -0.784 1.532 -1.177 3.189 -1.177 4.972 c 0 2.794 0.942 5.027 2.827 6.699 c 1.885 1.671 4.41 2.506 7.575 2.506 c 1.514 0 2.977 -0.218 4.387 -0.654 c 1.412 -0.437 2.717 -1.082 3.914 -1.936 l 1.352 1.88 c -1.449 1.086 -2.982 1.898 -4.604 2.437 c -1.619 0.539 -3.303 0.808 -5.049 0.808 c -1.791 0 -3.441 -0.225 -4.95 -0.675 s -2.843 -1.126 -4.004 -2.026 c -1.457 -1.133 -2.544 -2.439 -3.259 -3.92 c -0.715 -1.48 -1.072 -3.159 -1.072 -5.034 c 0 -1.579 0.244 -3.064 0.731 -4.457 s 1.214 -2.683 2.18 -3.872 c 1.355 -1.69 3.021 -2.978 4.999 -3.865 s 4.15 -1.33 6.518 -1.33 c 1.578 0 3.059 0.211 4.443 0.633 c 1.383 0.422 2.594 1.036 3.635 1.843 c 1.234 0.974 2.17 2.098 2.805 3.373 c 0.637 1.274 0.955 2.695 0.955 4.262 c 0 1.539 -0.305 2.959 -0.912 4.262 c -0.609 1.303 -1.492 2.417 -2.652 3.345 c -0.623 0.5 -1.334 0.892 -2.131 1.175 c -0.799 0.283 -1.621 0.424 -2.467 0.424 c -0.975 0 -1.721 -0.183 -2.242 -0.55 c -0.26 -0.183 -0.463 -0.415 -0.611 -0.694 S 46.908 33.638 46.908 33.28 z M 47.426 27.237 c -0.084 -0.697 -0.318 -1.233 -0.703 -1.609 c -0.387 -0.376 -0.895 -0.564 -1.525 -0.564 c -0.948 0 -1.789 0.562 -2.522 1.685 c -0.734 1.124 -1.101 2.456 -1.101 3.997 c 0 0.78 0.162 1.379 0.488 1.797 c 0.325 0.417 0.781 0.626 1.368 0.626 c 0.791 0 1.479 -0.271 2.065 -0.814 c 0.586 -0.542 0.996 -1.277 1.229 -2.205 L 47.426 27.237 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(220,103,84)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.08605fe63a6493c44a02c9b4bc20d190.svg";
export { ForwardRef as ReactComponent };